<div id="loading">
  <i class="fas fa-circle-notch fa-spin"></i>
  <h2 class="h3 condensed white-text">{{text}}</h2>
</div>